import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { PositionedSnackbar } from "./PositionedSnackbar";

export const ErrorSnackbar = ({ open, onClose, title = "Error", message, position = { vertical: "top", horizontal: "center" }, sx }) => {
  const baseStyles = {
    backgroundColor: "rgba(211, 47, 47, 0.92)",
    color: "#fff",

    width: {
      xs: "100%",
      sm: "fit-content",
    },

    minWidth: {
      xs: 0,
      sm: "300px",
    },

    maxWidth: {
      xs: "100%",
      sm: "600px",
    },

    boxSizing: "border-box",
    alignItems: "flex-start",

    maxHeight: "calc(100dvh - 80px)",
    overflowY: "auto",

    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
    wordBreak: "normal",

    fontSize: "clamp(0.75rem, 1.35vw, 0.9375rem)",
    lineHeight: 1.35,

    padding: "clamp(8px, 1.3vw, 12px) clamp(10px, 1.8vw, 16px)",

    "& .MuiAlert-icon": {
      color: "#fff",
      marginTop: "2px",
      marginRight: "clamp(6px, 1vw, 12px)",

      fontSize: "clamp(1.25rem, 2.5vw, 1.5rem)",
    },

    "& .MuiAlert-message": {
      flex: 1,
      minWidth: 0,
      padding: 0,
      overflowWrap: "anywhere",
    },

    "& .MuiAlert-action": {
      alignItems: "flex-start",
      marginRight: 0,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: "clamp(5px, 1.2vw, 14px)",
    },

    "& .MuiAlert-action .MuiIconButton-root": {
      padding: "clamp(2px, 0.7vw, 5px)",
    },

    "& .MuiAlert-action svg": {
      fontSize: "clamp(1.1rem, 2.3vw, 1.4rem)",
    },
  };

  const customStyles = Array.isArray(sx) ? sx : [sx];

  return (
    <PositionedSnackbar open={open} onClose={onClose} position={position}>
      <Alert onClose={onClose} severity="error" variant="filled" sx={[baseStyles, ...customStyles].filter(Boolean)}>
        <AlertTitle
          sx={{
            fontWeight: "bold",

            fontSize: "clamp(0.8125rem, 1.55vw, 1.0625rem)",
            lineHeight: 1.2,
            marginBottom: "clamp(2px, 0.4vw, 4px)",
          }}
        >
          {title}
        </AlertTitle>

        {message}
      </Alert>
    </PositionedSnackbar>
  );
};
